import { render, staticRenderFns } from "./StoreLocationItem.vue?vue&type=template&id=42454774&scoped=true&"
import script from "./StoreLocationItem.vue?vue&type=script&lang=js&"
export * from "./StoreLocationItem.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocationItem.vue?vue&type=style&index=0&id=42454774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42454774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42454774')) {
      api.createRecord('42454774', component.options)
    } else {
      api.reload('42454774', component.options)
    }
    module.hot.accept("./StoreLocationItem.vue?vue&type=template&id=42454774&scoped=true&", function () {
      api.rerender('42454774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/StoreLocationItem.vue"
export default component.exports